module.exports = __webpack_public_path__ + "assets/ParrotWithTie.8735ea7f.svg";